package com.example.event_management_system.util

import kotlin.js.Date
import kotlin.time.Instant
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

actual fun currentTimeMillis(): Long = Date.now().toLong()
actual fun currentLocalDate(): LocalDate =
    Instant.fromEpochMilliseconds(Date.now().toLong())
        .toLocalDateTime(TimeZone.UTC)
        .date

actual fun currentLocalDateTime(): LocalDateTime {
    val d = Date()
    return LocalDateTime(
        d.getFullYear(),
        d.getMonth() + 1,
        d.getDate(),
        d.getHours(),
        d.getMinutes(),
        d.getSeconds(),
        d.getMilliseconds() * 1_000_000
    )
}

